import { ReceptorBhe } from "./ReceptorBhe";

export class DatosCreacionBhe {
   //Los datos de creacion consideran la fecha de emision, datos de receptor y si la retencion es del emisor,
   //Engloba estos datos en el componente receptor bhe, desde donde se captura el unico formulario que
   //los contiene, antes de enviarlos al componente principal
   fechaEmision: Date;
   retencionEmisor: boolean;
   receptorBhe: ReceptorBhe;
}
